import React, {VoidFunctionComponent} from 'react';
import {NavLink} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import styles from './navigation.module.css';

const Navigation: VoidFunctionComponent<Record<string, unknown>> = () => (
  <nav className={styles.navigation}>
    <ul>
      <li className={styles.mapLink}>
        <NavLink to="/" activeClassName={styles.active} exact>
          <FormattedMessage id="navigation.map" />
        </NavLink>
      </li>
      <li className={styles.mapLink}>
        <NavLink
          to="/citizen-science"
          className={styles.navigationLink}
          activeClassName={styles.navigationLinkActive}>
          <FormattedMessage id="navigation.citizenScience" />
        </NavLink>
      </li>
      <li>
        <NavLink to="/imprint" activeClassName={styles.active}>
          <FormattedMessage id="navigation.imprint" />
        </NavLink>
      </li>
      <li>
        <NavLink to="/privacy" activeClassName={styles.active}>
          <FormattedMessage id="navigation.privacy" />
        </NavLink>
      </li>
      <li>
        <NavLink to="/terms-of-use" activeClassName={styles.active}>
          <FormattedMessage id="navigation.termsOfUse" />
        </NavLink>
      </li>
    </ul>
  </nav>
);

export default Navigation;
